export class Campus {
  id: string;
  nome: string;
  endereco: string;
  cep: string;
  idCidade: number;
  nomeCidade: string;
  uf: string;

  constructor(args) {
    Object.assign(this, args);
  }
}
